/*! Copyright (c) Safe As Milk. All rights reserved. */
class QuantityInput extends HTMLElement {
    #boundAdd;
    #boundSelect;
    #boundSubtract;
    #boundValidate;
    constructor() {
        super();
        this.#boundAdd = this.add.bind(this);
        this.#boundSubtract = this.subtract.bind(this);
        this.#boundValidate = this.validate.bind(this);
        this.#boundSelect = QuantityInput.#selectInputText.bind(this);
    }
    connectedCallback() {
        this.input = this.querySelector('input[type="number"]');
        this.minus = this.querySelector("button[minus]");
        this.plus = this.querySelector("button[plus]");
        this.min = Number(this.input.getAttribute("min") || 0);
        this.max = Number(this.input.getAttribute("max") || Infinity);
        this.step = Number(this.input.getAttribute("step") || 1);
        setTimeout((() => {
            this.minus?.addEventListener("click", this.#boundSubtract);
            this.plus?.addEventListener("click", this.#boundAdd);
            this.input?.addEventListener("change", this.#boundValidate);
            this.input?.addEventListener("select", this.#boundSelect);
            this.input?.addEventListener("click", this.#boundSelect);
        }));
    }
    disconnectedCallback() {
        this.minus?.removeEventListener("click", this.#boundSubtract);
        this.plus?.removeEventListener("click", this.#boundAdd);
        this.input?.removeEventListener("change", this.#boundValidate);
        this.input?.removeEventListener("select", this.#boundSelect);
        this.input?.removeEventListener("click", this.#boundSelect);
    }
    subtract() {
        const value = Number(this.input.value);
        if (value > this.min) {
            const newQuantity = value - Math.min(this.step, value - this.min);
            this.input.value = newQuantity;

            const associatedLineItemKeys = this.adjustAssociatedLineItemQuantities(this.input, newQuantity);

            this.dispatchEvent(new CustomEvent("update", {
                detail: {
                    value: this.input.value,
                    key: this.input.dataset.key,
                    addons: this.input.dataset?.addons,
                    parentKey: this.input.dataset?.parentKey,
                    associatedLineItemKeys: associatedLineItemKeys
                }
            }));
        }
    }
    add() {
        const value = Number(this.input.value);
        if (value < this.max) {
            const newQuantity = value + Math.min(this.step, this.max - value);
            this.input.value = newQuantity;

            const associatedLineItemKeys = this.adjustAssociatedLineItemQuantities(this.input, newQuantity);

            this.dispatchEvent(new CustomEvent("update", {
                detail: {
                    value: this.input.value,
                    key: this.input.dataset.key,
                    addons: this.input.dataset?.addons,
                    parentKey: this.input.dataset?.parentKey,
                    associatedLineItemKeys: associatedLineItemKeys
                }
            }));
        }
    }
    adjustAssociatedLineItemQuantities(input, newQuantity) {
        if (input.hasAttribute('data-associated-line-item-uuids')) {
            let associatedLineItemUuids = input.dataset.associatedLineItemUuids.split(',');

            if (!Array.isArray(associatedLineItemUuids)) {
                associatedLineItemUuids = [associatedLineItemUuids];
            }

            const associatedLineItemKeys = [];

            associatedLineItemUuids.forEach((associatedLineItemUuid) => {
                const associatedLineItemQuantityInput = document.querySelector(`input[data-uuid="${associatedLineItemUuid}"]`);

                if (!!(associatedLineItemQuantityInput)) {
                    associatedLineItemKeys.push(associatedLineItemQuantityInput.dataset.key);
                }
            });

            return associatedLineItemKeys;
        }

        return [];
    }
    validate(e) {
        const {value: value} = e.target;
        const testRegEx = /^[0-9]+$/;

        let newQuantity = value;

        if (!testRegEx.test(value) || Number(value) < this.min) {
            newQuantity = this.min;
            this.input.value = newQuantity;
        }
        if (Number(value) > this.max) {
            newQuantity = this.max;
            this.input.value = newQuantity;
        }

        const associatedLineItemKeys = this.adjustAssociatedLineItemQuantities(this.input, newQuantity);

        this.dispatchEvent(new CustomEvent("update", {
            detail: {
                value: this.input.value,
                key: this.input.dataset.key,
                addons: this.input.dataset?.addons,
                parentKey: this.input.dataset?.parentKey,
                associatedLineItemKeys: associatedLineItemKeys
            }
        }));
    }
    set value(value) {
        this.input.value = Number(value);
    }
    get value() {
        return Number(this.input.value);
    }
    static #selectInputText(e) {
        e.target.select();
    }
}

customElements.define("quantity-input", QuantityInput);
//# sourceMappingURL=quantity-input.js.map
